import { useTrans } from "@/i18n"

import { useCurrentUserIdentityType, useCurrentUserKyc } from "@/context/user"
import { UsersUserProfileIdentityTypeChoices } from "@/api/graphql"

import { MangoPaySCAEnrollBanner } from "./_components/MangopayScaEnrollBanner"
import { InvestorIdentityForm } from "./_components/InvestorIdentityForm"
import { BusinessVerificationForm } from "./_components/BusinessVerificationForm"

export const InvestorIdentity = () => {
	const t = useTrans("investor")

	const identityType = useCurrentUserIdentityType()
	const userKyc = useCurrentUserKyc()
	const usesHostedKyc = userKyc?.uses_hosted_verification ?? false
	const isBusiness =
		identityType === UsersUserProfileIdentityTypeChoices.Business

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("investor:identity.title"),
				})}
			</title>

			<MangoPaySCAEnrollBanner />

			{/* Business verification is email/manual — always visible for
			    business users, regardless of SCA or hosted-KYC state. */}
			{isBusiness && <BusinessVerificationForm />}

			{/* Legacy private upload form — shown whenever hosted flow is off.
			    The form itself renders a "complete SCA first" overlay when the
			    user hasn't finished SCA. */}
			{!isBusiness && !usesHostedKyc && <InvestorIdentityForm />}
		</>
	)
}
